export const profile_nav = [
  // {
  //   id: 1,
  //   title: 'Мой профиль',
  //   to: '/profile',
  //   icon: 'user',
  // },
  // {
  //   id: 3,
  //   title: 'Настройки рассылки',
  //   to: '/email',
  //   icon: 'mail',
  // },
  {
    id: 2,
    titleKey: 'labels.my_orders',
    to: '/profile/history',
    icon: 'history',
  },
  {
    id: 4,
    titleKey: 'labels.bonuses',
    to: '/profile/loyalty',
    icon: 'dollar',
  },
];
